const toggleMenu = (): void => {
  const menuButton = document.querySelector<HTMLElement>('.js-navButton');
  const menu = document.querySelector<HTMLElement>('.js-navMenu');

  if (!menuButton || !menu) return;

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('is-active');
    menu.classList.toggle('is-active');
  });
};

// 実行
toggleMenu();
